import { EventEmitter } from '@angular/core';
import { Component, OnInit, Input, Output } from '@angular/core';
import { IFormReportQuestion, IFormReportView } from '../../fi-form-report';
import { FiStateService } from '../../../../shared/fi-state-proxy/fi-state.proxy.service';
import { FormReportNavigation } from '../../fi-form-report-navigation';
import { isDefined } from '../../../../shared/utils';
import { FiStateNames } from '../../../../shared/fi-state-proxy/fi-state-names';

export interface IFormSubmissionEmitter {
    selectedSubmissionId: number;
    selectedAnswerSetId: number;
}

@Component({
    selector: 'fi-form-report-question-details',
    templateUrl: './fi-form-report-question-details.component.html',
    styleUrls: ['../../fi-form-report.component.scss'],
    standalone: false,
})
export class FiFormReportQuestionsDetailsComponent implements OnInit {
    @Input() question: IFormReportQuestion;
    @Input() formReport: IFormReportView;
    @Output() back = new EventEmitter();

    reportEndDate = new Date();
    reportStartDate: string;
    isUserReport: boolean = false;
    submissionData: IFormSubmissionEmitter;

    constructor(private stateService: FiStateService) {}

    ngOnInit() {
        this.reportStartDate = this.formReport.CreatedOn;
    }

    goBack() {
        this.back.emit();
    }

    scrollToAnswer(index?: number) {
        let answerForm: HTMLElement;
        if (isDefined(index)) {
            answerForm = document.getElementById(`answer-${index}`);
        } else {
            let emptyAnswersTableIndex = this.question.Answers.findIndex((answer) => !answer.AnswerValue);
            answerForm = document.getElementById(`answer-${emptyAnswersTableIndex}`);
        }
        if (answerForm) {
            answerForm.scrollIntoView({ behavior: 'smooth' });
        }
    }

    getAnswerId(index: number) {
        return `answer-${index}`;
    }

    showQuestionDetails() {
        this.isUserReport = false;
    }

    showUserReport(submissionData: IFormSubmissionEmitter) {
        this.submissionData = submissionData;

        this.stateService.go(FiStateNames.Form.Report.View, {
            id: this.formReport.Id,
            pos: FormReportNavigation.UserReport,
        });

        this.isUserReport = true;
        this.stateService.setBackButtonHandler(() => {
            this.isUserReport = false;
            this.goBack();
        });
    }

    onStartDateChange(event) {
        this.reportStartDate = event.value;
        // sort?
    }

    onEndDateChange(event) {
        this.reportEndDate = event.value;
        // sort?
    }
}
